module.exports = __webpack_public_path__ + "media/illustrations/locations-245c8889.svg";